(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3949],{

/***/ 54535:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/luxury-hotels-e-gift-card",
      function () {
        return __webpack_require__(66724);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LH": function() { return /* binding */ getCountryCodeOptions; },
  "P8": function() { return /* binding */ getCurrencyOptions; },
  "bM": function() { return /* binding */ getCurrencyOptionsVoucher; },
  "rI": function() { return /* binding */ radioOptions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./blocks/sign-up/CountryCode.module.scss
var CountryCode_module = __webpack_require__(78717);
var CountryCode_module_default = /*#__PURE__*/__webpack_require__.n(CountryCode_module);
;// CONCATENATED MODULE: ./blocks/sign-up/CountryCode.tsx



var CountryCode = function(param) {
    var name = param.name, code = param.code;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CountryCode_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CountryCode_module_default()).dialCode,
                children: code
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CountryCode_module_default()).name,
                children: name
            })
        ]
    });
};
/* harmony default export */ var sign_up_CountryCode = (CountryCode);

;// CONCATENATED MODULE: ./data/currencyCodeMap.ts
var currencyCodeMap = {
    GBP: "United Kingdom",
    EUR: "Europe",
    USD: "United States"
};

;// CONCATENATED MODULE: ./blocks/sign-up/options.ts


var radioOptions = [
    {
        value: "yes",
        label: "Yes"
    },
    {
        value: "no",
        label: "No"
    }, 
];
var getCountryCodeOptions = function(countryCodes) {
    return countryCodes.map(function(param) {
        var name = param.name, code = param.code, id = param.id;
        return {
            value: id.toString(),
            html: sign_up_CountryCode({
                name: name,
                code: code
            })
        };
    });
};
var getCurrencyOptions = function(currencies) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _showSymbol = ref.showSymbol, showSymbol = _showSymbol === void 0 ? true : _showSymbol;
    return currencies.map(function(param) {
        var code = param.code, symbol = param.symbol;
        var name = showSymbol ? "".concat(symbol, " - ").concat(code) : code;
        return {
            value: code,
            name: name
        };
    });
};
var getCurrencyOptionsVoucher = function(currencies) {
    return currencies.map(function(param) {
        var code = param.code, symbol = param.symbol;
        var country = currencyCodeMap[code] || "";
        var name = country ? "".concat(country, " - ").concat(symbol, " ").concat(code) : "".concat(symbol, " ").concat(code);
        return {
            value: code,
            name: name
        };
    });
};


/***/ }),

/***/ 41046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Checkbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76642);
/* harmony import */ var components_icons_CheckboxIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57680);
/* harmony import */ var components_icons_CheckboxIconChecked__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54166);








var CheckBox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function CheckBoxWithForwardRef(_param, ref) {
    var label = _param.label, labelHtml = _param.labelHtml, _labelAction = _param.labelAction, labelAction = _labelAction === void 0 ? function() {} : _labelAction, errorMsg = _param.errorMsg, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "label",
        "labelHtml",
        "labelAction",
        "errorMsg"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "checkbox-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Checkbox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
                        ref: ref,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_CheckboxIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                        checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_CheckboxIconChecked__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                        sx: {
                            padding: 0,
                            "& rect": {
                                stroke: errorMsg ? "#d32f2f" : "#B2B2B2"
                            }
                        }
                    })),
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        className: "checkbox-container__label",
                        children: label
                    }),
                    labelHtml && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "checkbox-container__label ".concat(errorMsg ? "error" : ""),
                        onClick: labelAction,
                        children: labelHtml
                    })
                ]
            }),
            errorMsg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "checkbox-container__helper-text",
                children: errorMsg
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (CheckBox);


/***/ }),

/***/ 46945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87536);
/* harmony import */ var _CheckBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41046);







var ControlledCheckBox = function(props) {
    var name = props.name, checked = props.checked, middleware = props.middleware, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "name",
        "checked",
        "middleware"
    ]);
    var onChange = function(event, checked) {
        if (middleware) {
            middleware(checked);
        }
        field.onChange(checked);
    };
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useController */ .bc)({
        name: name,
        defaultValue: checked
    }), field = ref.field, error = ref.fieldState.error;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CheckBox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest, field), {
        checked: field.value,
        errorMsg: error === null || error === void 0 ? void 0 : error.message,
        onChange: onChange
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ControlledCheckBox);


/***/ }),

/***/ 11216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DateSelector_ControlledDateSelector; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DatePicker/DatePicker.js + 76 modules
var DatePicker = __webpack_require__(91205);
// EXTERNAL MODULE: ./components/container/index.ts
var container = __webpack_require__(49985);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./components/TextField/TextField.tsx
var TextField = __webpack_require__(90943);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./hooks/useForceUpdate.ts


function useForceUpdate() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), value = ref[0], setValue = ref[1];
    return function() {
        return setValue(function(value) {
            return value + 1;
        });
    }; // update state to force render
}
/* harmony default export */ var hooks_useForceUpdate = (useForceUpdate); // escape hatch for scenarios where you can't control the state of a component (i.e. a third party component)

;// CONCATENATED MODULE: ./components/DateSelector/DateSelector.tsx











var DateSelector = /*#__PURE__*/ (0,react.forwardRef)(function DateSelector(_param, ref) {
    var label = _param.label, error = _param.error, views = _param.views, value = _param.value, name = _param.name, _dateFormat = _param.dateFormat, dateFormat = _dateFormat === void 0 ? constants/* USER_BIRTH_DAY_DATE_FORMAT */.P7 : _dateFormat, _disabledFuture = _param.disabledFuture, disabledFuture = _disabledFuture === void 0 ? false : _disabledFuture, errorMsg = _param.errorMsg, onChange = _param.onChange, _setError = _param.setError, setError = _setError === void 0 ? function() {} : _setError, _showHeaderYear = _param.showHeaderYear, showHeaderYear = _showHeaderYear === void 0 ? true : _showHeaderYear, mt = _param.mt, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "error",
        "views",
        "value",
        "name",
        "dateFormat",
        "disabledFuture",
        "errorMsg",
        "onChange",
        "setError",
        "showHeaderYear",
        "mt"
    ]);
    // set anchor el for popper to attach to
    var anchorEl = (0,react.useRef)(null);
    if (!anchorEl.current) {
        anchorEl.current = document.querySelector('input[name="'.concat(name, '"]'));
    }
    var handleChange = function(date) {
        var value = moment_default()(date).format(constants/* DATE_FORMAT_REQUEST */.Og);
        onChange(value);
    };
    // fix when the DatePicker is conditionally rendered and
    // it's not rendered properly on the first time
    // (only happens on production build)
    //TODO: investigate why this happens
    var forceUpdate = hooks_useForceUpdate();
    (0,react.useEffect)(function() {
        forceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: "text-field-container",
        mt: mt,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-field-container__label",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-field-container__content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker/* DatePicker */.M, (0,_object_spread/* default */.Z)({
                    PaperProps: {
                        className: !showHeaderYear ? "hide-header-year" : ""
                    },
                    PopperProps: {
                        anchorEl: anchorEl.current
                    },
                    views: views,
                    value: value,
                    onChange: handleChange,
                    inputFormat: dateFormat,
                    disableFuture: disabledFuture,
                    renderInput: function(textFieldProps) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, textFieldProps), {
                            name: name,
                            inputRef: ref,
                            value: value,
                            FormHelperTextProps: {
                                className: "text-field-container__helper-text"
                            },
                            size: "small",
                            error: error,
                            errorMsg: errorMsg,
                            sx: {
                                "& input::placeholder": {
                                    textTransform: "uppercase"
                                }
                            }
                        }));
                    }
                }, rest))
            })
        ]
    });
});
/* harmony default export */ var DateSelector_DateSelector = (DateSelector);

;// CONCATENATED MODULE: ./components/DateSelector/ControlledDateSelector.tsx





var ControlledDateSelector = function(props) {
    var name = props.name;
    var ref = (0,index_esm/* useController */.bc)({
        name: name
    }), field = ref.field, error = ref.fieldState.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSelector_DateSelector, (0,_object_spread/* default */.Z)({
        errorMsg: error === null || error === void 0 ? void 0 : error.message
    }, field, props));
};
/* harmony default export */ var DateSelector_ControlledDateSelector = (ControlledDateSelector);


/***/ }),

/***/ 46050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var _RadioButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92661);






var ControlledRadioButton = function(props) {
    var name = props.name, value = props.value, _onPostChange = props.onPostChange, onPostChange = _onPostChange === void 0 ? function() {} : _onPostChange;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useController */ .bc)({
        name: name,
        defaultValue: value
    }), field = ref.field, error = ref.fieldState.error;
    var handleChange = function(name, value) {
        field.onChange(value);
        onPostChange();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RadioButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, field), {
        onRadioButtonClick: handleChange,
        errorMsg: error === null || error === void 0 ? void 0 : error.message
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ControlledRadioButton);


/***/ }),

/***/ 92661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Radio__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45993);
/* harmony import */ var _mui_material_RadioGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68061);
/* harmony import */ var _mui_material_FormControlLabel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20847);
/* harmony import */ var components_icons_RadioCheckedIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81440);
/* harmony import */ var components_icons_RadioIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10604);
/* harmony import */ var _RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93636);
/* harmony import */ var _RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22538);









var RadioButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function RadioButtonWithRef(param, ref) {
    var name = param.name, value = param.value, options = param.options, onRadioButtonClick = param.onRadioButtonClick, errorMsg = param.errorMsg, className = param.className;
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        onRadioButtonClick(name, value);
    }, [
        name,
        onRadioButtonClick
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_RadioGroup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ref: ref,
                "aria-labelledby": "radio-buttons-group-label",
                name: "radio-buttons-group",
                value: value !== null && value !== void 0 ? value : "",
                onChange: function(e) {
                    return handleChange(e.target.value);
                },
                className: (_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().radioContainer),
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControlLabel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: "".concat((_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().radioButton), " ").concat(errorMsg && (_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().error)),
                        value: option.value,
                        control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Radio__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_RadioIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                            checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_RadioCheckedIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                        }),
                        label: option.label
                    }, option.value);
                })
            }),
            errorMsg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_text__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
                color: "forms-red",
                children: errorMsg
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 61339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ControlledSelect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80434);






var ControlledSelect = function(props) {
    var name = props.name, defaultValue = props.defaultValue;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useController */ .bc)({
        name: name
    }), _field = ref.field, onChange = _field.onChange, value = _field.value;
    var handleChange = function(name, value) {
        onChange(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        onChange: handleChange,
        value: value || defaultValue
    }));
};


/***/ }),

/***/ 80434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Select; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(69397);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js
var Menu = __webpack_require__(24486);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(63931);
;// CONCATENATED MODULE: ./hooks/useBodyScrollLock.ts

var useBodyScrollLock = function() {
    var originalPaddingRight = (0,react.useRef)(null);
    var originalTop = (0,react.useRef)(0);
    var isLocked = (0,react.useRef)(false);
    var disableScroll = function() {
        if (false) {}
        // Check if body already has overflow hidden
        if (window.getComputedStyle(document.body).overflow === "hidden") {
            isLocked.current = false; // Indicate that the hook didn't lock the scroll
            return;
        }
        // Save the current scroll position
        originalTop.current = window.scrollY;
        // Add padding to prevent layout shift due to scrollbar disappearance
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        originalPaddingRight.current = document.body.style.paddingRight;
        if (scrollBarGap > 0) {
            document.body.style.paddingRight = "".concat(scrollBarGap, "px");
        }
        // Lock scroll using `position: fixed` and save the scroll offset in `top`
        document.body.style.position = "fixed";
        document.body.style.top = "-".concat(originalTop.current, "px");
        document.body.style.left = "0";
        document.body.style.width = "100%";
        isLocked.current = true;
    };
    var enableScroll = function() {
        if ( false || !isLocked.current) return;
        // Get the original scroll position from the `top` property
        var scrollY = Math.abs(parseInt(document.body.style.top || "0", 10));
        // Temporarily disable scroll animation
        var originalScrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = "auto";
        // Restore original styles
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.width = "";
        if (originalPaddingRight.current !== null) {
            document.body.style.paddingRight = originalPaddingRight.current;
        }
        // Restore the scroll position without animation
        window.scrollTo(0, scrollY);
        // Restore the original scroll-behavior
        document.documentElement.style.scrollBehavior = originalScrollBehavior || "";
        isLocked.current = false;
    };
    return {
        disableScroll: disableScroll,
        enableScroll: enableScroll
    };
};
/* harmony default export */ var hooks_useBodyScrollLock = (useBodyScrollLock);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(91441);
// EXTERNAL MODULE: ./components/icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(29661);
;// CONCATENATED MODULE: ./components/Select/Select.tsx










function Select(param) {
    var label = param.label, value = param.value, name = param.name, options = param.options, onChange = param.onChange, _upperCaseOptions = param.upperCaseOptions, upperCaseOptions = _upperCaseOptions === void 0 ? false : _upperCaseOptions, _layout = param.layout, layout = _layout === void 0 ? "FORM" : _layout;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var ref1 = hooks_useBodyScrollLock(), disableScroll = ref1.disableScroll, enableScroll = ref1.enableScroll;
    var open = Boolean(anchorEl);
    var handleMenuOpen = function(event) {
        setAnchorEl(event.currentTarget);
        disableScroll();
    };
    var handleClose = function() {
        setAnchorEl(null);
        enableScroll();
    };
    var handleSelect = function(selectedValue) {
        onChange(name, selectedValue);
        handleClose();
    };
    var getPresentedValue = function() {
        var selectedOption = options.find(function(option) {
            return option.value === value;
        });
        return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.html) || value;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "select-container".concat(open ? " select-container--open" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "select-container__label",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                id: "basic-button",
                disableRipple: true,
                className: classnames_default()({
                    "form-layout": layout === "FORM",
                    "currency-layout": layout === "CURRENCY"
                }),
                onClick: handleMenuOpen,
                endIcon: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
                    width: 12,
                    height: 6
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                    width: 12,
                    height: 6
                }),
                children: getPresentedValue()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                MenuListProps: {
                    sx: {
                        borderTop: "1px solid #000",
                        minWidth: "140px"
                    }
                },
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        disableRipple: true,
                        selected: option.value === value,
                        onClick: function() {
                            return handleSelect(option.value);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                textTransform: upperCaseOptions ? "uppercase" : "none"
                            },
                            children: option.name || option.html || option.value
                        })
                    }, option.value);
                })
            })
        ]
    });
}


/***/ }),

/***/ 17073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ControlledTextField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87536);
/* harmony import */ var _TextField__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90943);






var ControlledTextField = function(_param) {
    var rules = _param.rules, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "rules"
    ]);
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useFormContext */ .Gc)(), control = ref.control, clearErrors = ref.clearErrors;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            clearErrors(props.name);
        };
    }, [
        clearErrors,
        props.name
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .Controller */ .Qr, {
        name: props.name,
        defaultValue: "",
        control: control,
        rules: rules,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                errorMsg: error === null || error === void 0 ? void 0 : error.message
            }, field, props));
        }
    });
};


/***/ }),

/***/ 66724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ luxury_hotels_e_gift_card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/schema/zodUtils.ts
var zodUtils = __webpack_require__(28461);
// EXTERNAL MODULE: ./node_modules/zod/v3/types.js + 4 modules
var types = __webpack_require__(45901);
// EXTERNAL MODULE: ./node_modules/zod/v3/ZodError.js
var ZodError = __webpack_require__(79711);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./utils/currencyHelper.ts
var currencyHelper = __webpack_require__(24480);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/constants.ts
var MAX_AMOUNT_DIGITS = 4;
var MAX_AMOUNT = 1500;
var MAX_NAME_CHARS = "UVUVWEVWEVWE ONYETENYEVWE UGWEMUBWEM OSAS".length;
var MAX_EMAIL_CHARS = 254;
var SEND_DATE_DISPLAY_FORMAT = "DD/MM/YY";

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/schema.ts






var voucherFormSchema = types/* object */.Ry({
    amount: types/* string */.Z_().default("50"),
    currency: types/* enum */.Km(constants/* supportedCurrencyCodes */.VI).default("GBP"),
    creator_name: types/* string */.Z_().min(1, {
        message: "Please enter your name"
    }).default(""),
    creator_email: types/* string */.Z_().email({
        message: "Please enter a valid email"
    }).default(""),
    self_send: types/* boolean */.O7().default(false),
    recipient_name: types/* string */.Z_().optional().default(""),
    recipient_email: types/* string */.Z_().email({
        message: "Please enter a valid email"
    }).default(""),
    send_date_option: types/* enum */.Km([
        "now",
        "later"
    ]).default("now"),
    send_date: types/* string */.Z_().default(new Date().toString()),
    message: types/* string */.Z_().default(""),
    custom_gift_card_id: types/* number */.Rx().optional()
}).superRefine(function(param, ctx) {
    var amount = param.amount, send_date = param.send_date, send_date_option = param.send_date_option, currency = param.currency;
    var amountNumber = Number(amount.replace(/,/g, ""));
    if (amountNumber < 50) {
        var minimumAmountText = (0,currencyHelper/* currencyHelper */.a)(50, currency);
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            message: "The minimum amount for a gift card is ".concat(minimumAmountText),
            path: [
                "amount"
            ]
        });
    }
    if (amountNumber > MAX_AMOUNT) {
        var maximumAmountText = (0,currencyHelper/* currencyHelper */.a)(MAX_AMOUNT, currency);
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            message: "The maximum amount for a gift card is ".concat(maximumAmountText),
            path: [
                "amount"
            ]
        });
    }
    if (send_date_option === "now") {
        return types/* NEVER */.C4;
    }
    var formattedSendDate = moment_default()(send_date, constants/* DATE_FORMAT_REQUEST */.Og, true);
    if (!formattedSendDate.isValid()) {
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            message: "Please enter a valid date",
            path: [
                "send_date"
            ]
        });
    }
    var isPastDate = formattedSendDate.isBefore(moment_default()(), "day");
    if (isPastDate) {
        ctx.addIssue({
            code: ZodError/* ZodIssueCode.custom */.NL.custom,
            message: "Please enter a valid date",
            path: [
                "send_date"
            ]
        });
    }
});
var defaultVoucher = (0,zodUtils/* getDefaults */.J)(voucherFormSchema);
var multiVoucherFormSchema = types/* object */.Ry({
    vouchers: types/* array */.IX(voucherFormSchema).min(1).default([
        defaultVoucher
    ])
});
var defaultMultiVoucher = (0,zodUtils/* getDefaults */.J)(multiVoucherFormSchema);


;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/context/context.ts




var VoucherContext = (0,react.createContext)(undefined);
var initialState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultMultiVoucher), {
    creditCard: {
        brand: "",
        name: "",
        number: "",
        expiry: "",
        cvc: ""
    }
});
var VoucherProvider = function(param) {
    var children = param.children, currencies = param.currencies, customGiftCards = param.customGiftCards;
    var ref = (0,react.useState)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        currencies: currencies,
        customGiftCards: customGiftCards
    })), state = ref[0], setState = ref[1];
    var dispatchSliceOfState = function(newState) {
        setState(function(prevState) {
            return (0,_object_spread/* default */.Z)({}, prevState, newState);
        });
    };
    var resetState = function() {
        dispatchSliceOfState(initialState);
    };
    return (0,react.createElement)(VoucherContext.Provider, {
        value: {
            state: state,
            setState: dispatchSliceOfState,
            resetState: resetState
        }
    }, children);
};
var useVoucherContext = function() {
    var context = (0,react.useContext)(VoucherContext);
    if (context === undefined) {
        throw new Error("useVoucherContext must be used within a VoucherProvider");
    }
    return context;
};


;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/context/index.ts


// EXTERNAL MODULE: ./blocks/DownloadApp/DownloadApp.tsx + 2 modules
var DownloadApp = __webpack_require__(31968);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./blocks/sign-up/schemas.ts
var schemas = __webpack_require__(6319);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(56312);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
// EXTERNAL MODULE: ./components/Button/BaseButton.tsx
var BaseButton = __webpack_require__(26200);
;// CONCATENATED MODULE: ./assets/svg/Lock.svg
var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgLock = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 20,
  height: 22,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
  clipPath: "url(#Lock_svg__a)",
  fill: "#191919"
}, /*#__PURE__*/react.createElement("path", {
  d: "M7.953 14.309a2.054 2.054 0 0 0 1.545 2.006v2.257h1.003v-2.257a2.05 2.05 0 1 0-2.548-2.006ZM10 13.269a1.048 1.048 0 1 1 .01 2.096 1.048 1.048 0 0 1-.01-2.097Z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M16.352 8.257V6.62A6.376 6.376 0 0 0 4.053 4.14a6.375 6.375 0 0 0-.448 2.479v1.637H2v13.926h16V8.257h-1.648ZM4.608 6.62a5.372 5.372 0 1 1 10.741 0v1.637H4.61V6.62Zm12.389 14.56H3.003V9.26h13.994v11.92Z"
}))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
  id: "Lock_svg__a"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v22H0z"
})))));
/* harmony default export */ var Lock = (SvgLock);
// EXTERNAL MODULE: ./blocks/e-gift-card/buy/payment/summary/Summary.module.scss
var Summary_module = __webpack_require__(42488);
var Summary_module_default = /*#__PURE__*/__webpack_require__.n(Summary_module);
// EXTERNAL MODULE: ./blocks/e-gift-card/buy/payment/summary/custom-card-summary/CustomCardSummary.module.scss
var CustomCardSummary_module = __webpack_require__(13652);
var CustomCardSummary_module_default = /*#__PURE__*/__webpack_require__.n(CustomCardSummary_module);
;// CONCATENATED MODULE: ./assets/svg/BlackGiftCard.svg
var _rect, BlackGiftCard_g;
function BlackGiftCard_extends() { return BlackGiftCard_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, BlackGiftCard_extends.apply(null, arguments); }

const SvgBlackGiftCard = props => /*#__PURE__*/react.createElement("svg", BlackGiftCard_extends({
  viewBox: "0 0 125 85",
  preserveAspectRatio: "xMinYMin slice",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/react.createElement("mask", {
  id: "BlackGiftCard_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 125,
  height: 85
}, _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
  width: 125,
  height: 85,
  rx: 10,
  fill: "#C4C4C4"
}))), BlackGiftCard_g || (BlackGiftCard_g = /*#__PURE__*/react.createElement("g", {
  mask: "url(#BlackGiftCard_svg__a)"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#191919",
  d: "M0 0h125v85H0z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M111.911 25.458c-1.19-.02-1.735-.05-2.125-.122-1.304-.239-2.27-.701-2.962-1.418-.309-.32-.751-.973-.707-1.043.015-.025.108-.062.206-.083.327-.07 1.874-.638 2.715-.997.815-.348 1.024-.488 1.024-.685 0-.295.006-.293-3.716-1.073-1.937-.406-3.535-.75-3.551-.767-.015-.015.063-.123.175-.24a4.17 4.17 0 0 0 1.107-2.435c.021-.19.057-.345.081-.345.077 0 1.488-2.376 1.488-2.506 0-.172-.123-.272-.61-.497-.404-.186-1.564-.587-2.025-.699-.191-.046-.24-.085-.264-.207-.143-.711-.402-1.173-.834-1.636-.354-.38-1.008-.736-1.672-.795-1.378-.121-2.114.656-2.288.832-.38.384-.662.897-.76 1.383l-.06.303-.339.066c-.436.085-1.666.493-2.147.711-.412.187-.534.355-.42.578.253.492 1.465 2.428 1.547 2.472.075.04.102.117.102.292 0 .644.405 1.645.915 2.264.166.202.294.366.284.366-.022 0-7.021 1.476-7.198 1.518-.282.067-.395.417-.194.599.237.214 2.565 1.134 3.744 1.478.33.097.609.183.62.192.01.009-.047.136-.127.283-.46.845-1.49 1.577-2.707 1.923-.87.247-1.446.312-3.01.338-.804.013-1.515.036-1.58.05-.18.037-.258.285-.187.602.076.339.129.434.405.734.419.454 1.07.675 2 .676l.5.001.484 2.748c.341 1.94.512 2.788.582 2.885.112.158.32.203.457.1.05-.04.464-.838.918-1.773.454-.936.84-1.717.859-1.735.018-.019.034.113.034.293 0 .482.142 1.276.338 1.886a7.501 7.501 0 0 0 1.574 2.758l.353.396-.305.249c-.781.636-1.733.8-2.612.447-.424-.17-.599-.63-.361-.95.224-.301.558-.215.752.194.195.41.516.486.698.166.07-.123.068-.17-.02-.4-.202-.53-.638-.854-1.152-.857-.308 0-.494.084-.74.34-.24.25-.347.533-.347.916 0 .265.032.375.18.621.437.73 1.916 1.614 3.297 1.97.656.169 1.537.223 2.09.13.508-.086 1.155-.403 1.524-.748l.274-.256.444.094c.603.126 1.79.167 2.412.082l.499-.068.229.22c.765.742 1.86.98 3.205.725.365-.112.733-.213 1.103-.299 1.254-.447 2.399-1.24 2.718-1.897.225-.465.032-1.205-.4-1.535-.26-.198-.787-.248-1.076-.102-.361.182-.604.48-.717.873-.076.265.075.477.341.479.161 0 .261-.099.395-.397.114-.253.386-.412.565-.33.126.057.304.37.304.536 0 .053-.05.178-.113.279-.13.21-.487.367-1.069.468a2.412 2.412 0 0 1-1.87-.505l-.21-.173.398-.394c1.243-1.234 1.968-2.765 2.17-4.581l.06-.541.744 1.555c.93 1.945.888 1.875 1.13 1.875.139 0 .215-.035.274-.125.044-.068.155-.546.245-1.063.09-.516.308-1.752.485-2.747l.32-1.809h.526c.881-.002 1.534-.218 1.944-.644.272-.282.428-.643.43-.99.002-.462.048-.45-1.793-.48Zm-23.275 1.384c-.644-.03-1.028-.16-1.292-.434l-.155-.162h.946c.52 0 .956.019.969.041.013.023.041.163.063.312l.04.27-.571-.027Zm19.787-5.633c.075.03 0 .08-.304.2-3.253 1.282-5.752 1.63-7.04.978-.318-.16-.816-.52-.816-.778 0-.266.005-.97.005-.97 0-.252.112-.282.465-.382.195-.055.57-.157.828-.247s.507-.153.552-.141c.046.012 6.255 1.319 6.31 1.34Zm-4.196-7.523c.277.107.515.205.529.219.013.014-.195.387-.464.83l-.487.806-.197-.038a13.614 13.614 0 0 0-1.881-.255 12.91 12.91 0 0 1-.878-.084c-.013-.01.017-.062.067-.117.144-.16.259-.488.259-.742 0-.337-.083-.584-.278-.827-.168-.21-.169-.212-.072-.376.121-.205.245-.21 1.127-.052.744.133 1.576.366 2.275.636ZM98.03 11.84c.234-.516.69-.93 1.24-1.127.419-.149 1.118-.113 1.531.08.424.197.832.591 1.035.999.206.411.218.56.043.518a5.878 5.878 0 0 0-.523-.068c-.327-.031-.405-.057-.433-.145-.049-.156-.347-.48-.526-.572-.085-.044-.3-.08-.478-.08-.393 0-.754.2-.922.513-.115.214-.065.197-.844.293-.278.034-.297-.029-.123-.412Zm2.427 2.45c0 .56-.78.72-1.022.21a.525.525 0 0 1 .214-.685c.208-.127.26-.13.502-.028.223.093.306.23.306.502Zm-4.403 1.149c-.156-.21-.95-1.556-.95-1.61 0-.066.349-.203 1.132-.445.65-.2 1.185-.318 1.903-.419.77-.107.747-.11.88.117l.12.2-.135.145c-.255.273-.326.486-.304.916.016.318.05.443.168.622l.149.224-.453.035c-.656.051-1.375.137-1.94.232-.47.078-.5.077-.57-.018Zm.704 1.899c-.146-.417-.242-1.096-.162-1.145.082-.051 1.44-.218 2.206-.27.95-.066 1.612-.067 2.534-.002.457.032 1.099.1 1.425.152l.594.094.017.2c.025.297-.133.902-.358 1.372-.225.469-.846 1.142-1.296 1.403-.366.212-1.326.476-1.73.475-1.425-.004-2.762-.948-3.23-2.28Zm-5.092 4.074c-.297-.114-.526-.222-.51-.239.024-.023 6.629-1.435 6.634-1.438.005-.004.185.078.4.18.214.104.564.23.777.283l.386.095s-.1 1.467-.223 1.607c-1.01 1.148-3.673.974-7.464-.488Zm-.847 10.383c-.01-.03-.192-1.037-.404-2.237-.487-2.753-.557-3.147-.593-3.296-.024-.105-.001-.123.184-.142.117-.012.23-.026.253-.031.01-.003.97-.177 1.225-.256 1.48-.451 2.532-1.357 3.172-2.446.14-.238.139-.281.252-.249.072.02.14.023.14.034 0 .01-.326.688-.724 1.505-1.386 2.842-3.478 7.202-3.505 7.118Zm6.418 5.078c-.714.544-2.088.555-3.457.027l-.461-.177.397-.101a3.62 3.62 0 0 0 1.45-.769c.163-.148.303-.271.312-.273.01-.001.15.1.315.223.163.124.6.382.969.573l.671.347-.196.15Zm8.761-.136.393.1-.259.113c-.938.407-2.099.556-2.834.365-.347-.09-.868-.355-.864-.439.001-.027.172-.115.379-.195.46-.179 1.082-.495 1.343-.682.106-.077.214-.14.24-.142.025-.002.162.099.303.224.328.29.8.527 1.299.656Zm.812-6.114a6.806 6.806 0 0 1-3.575 5.08c-2.169 1.121-4.783 1-6.771-.312-1.46-.964-2.438-2.319-2.895-4.01-.129-.478-.142-.624-.145-1.63-.006-1.588 0-1.607 1.297-4.267l1.042-2.138 1.009-.004c.856-.003 1.073-.022 1.44-.123.556-.154 1.008-.397 1.31-.705.133-.135.254-.245.27-.245.017 0 .151.123.298.272.518.523 1.291.812 2.327.869.536.029 1.524-.036 1.872-.123.113-.029.206.143 1.232 2.278.822 1.712 1.133 2.416 1.202 2.723.125.552.168 1.726.087 2.335Zm3.414-3.821-.495 2.778c-.21 1.18-.393 2.159-.407 2.173-.014.014-4.173-8.619-4.173-8.629 0-.016.113-.054.226-.076.019-.003.081.099.139.227.516 1.148 1.771 2.139 3.221 2.543.226.063 1.552.303 1.582.332.012.012-.03.305-.093.652Zm2.495-.337c-.272.26-.712.387-1.328.387h-.458l.035-.207.066-.359.03-.152h.934c.67 0 .934.018.934.064 0 .035-.096.155-.213.267Z",
  fill: "#BAA57E"
}), /*#__PURE__*/react.createElement("path", {
  d: "M100.973 16.692c-.263 0-.274.007-.337.198-.123.371-.651.536-.954.297a.8.8 0 0 1-.212-.303c-.066-.183-.082-.192-.334-.192-.23 0-.265.015-.265.112 0 .175.156.507.32.682.469.5 1.329.478 1.76-.044.15-.183.293-.518.293-.687 0-.038-.106-.063-.271-.063ZM105.545 28.345c-.714-2.884-3.45-4.732-6.337-4.283a5.629 5.629 0 0 0-3.1 1.572 5.614 5.614 0 0 0-.516 7.391c.574.762 1.205 1.268 2.122 1.7.824.39 1.29.488 2.325.491 1.082.003 1.575-.105 2.484-.547a5.633 5.633 0 0 0 2.989-3.646c.198-.747.213-1.954.033-2.678Zm-.422 2.561c-.256.913-.642 1.608-1.266 2.276a5.326 5.326 0 0 1-2.689 1.547c-.544.121-1.653.122-2.191.002-1.997-.446-3.61-2.065-4.012-4.023-.11-.538-.114-1.624-.007-2.125a5.251 5.251 0 0 1 4.033-4.071c.57-.127 1.898-.087 2.456.074a5.283 5.283 0 0 1 3.727 4.027c.116.572.089 1.794-.051 2.293Z",
  fill: "#BAA57E"
}), /*#__PURE__*/react.createElement("path", {
  d: "M96.587 31.984a.411.411 0 0 0 .308-.131.484.484 0 0 0 .14-.328v-4.039a.458.458 0 0 0-.14-.32.401.401 0 0 0-.308-.139h-.091v-.073h1.535v.073h-.091a.423.423 0 0 0-.386.226.46.46 0 0 0-.063.233v4.345h1.002c.346 0 .61-.08.793-.24.182-.16.334-.399.455-.715h.07l-.406 1.181h-2.91v-.073h.092ZM100.42 31.984a.412.412 0 0 0 .309-.131.49.49 0 0 0 .14-.328v-4.082a.46.46 0 0 0-.147-.292.416.416 0 0 0-.302-.124h-.084l-.007-.073h2.054c.145 0 .301-.014.47-.044.173-.029.294-.058.364-.087v.918h-.07v-.13a.417.417 0 0 0-.119-.3.38.38 0 0 0-.274-.13h-1.429v2.252h1.184a.342.342 0 0 0 .238-.11.352.352 0 0 0 .099-.255v-.102h.07v1.152h-.07v-.11a.343.343 0 0 0-.099-.247.317.317 0 0 0-.231-.11h-1.191v2.18h1.002c.346 0 .61-.08.792-.24.182-.16.334-.399.456-.715h.07l-.407 1.181h-2.909v-.073h.091Z",
  fill: "#BAA57E"
}))));
/* harmony default export */ var BlackGiftCard = (SvgBlackGiftCard);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/payment/summary/custom-card-summary/CustomCardSummary.tsx





var CustomCardSummary = function(param) {
    var customGiftCardId = param.customGiftCardId;
    var ref = useVoucherContext(), customGiftCards = ref.state.customGiftCards;
    if (!customGiftCardId || !customGiftCards) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackGiftCard, {});
    }
    var card = customGiftCards.find(function(card) {
        return card.id === customGiftCardId;
    });
    if (!card) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackGiftCard, {});
    }
    var image_url = card.image_url, name = card.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CustomCardSummary_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CustomCardSummary_module_default()).imageContainer,
            children: image_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: image_url,
                alt: name || "Gift card image"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackGiftCard, {})
        })
    });
};
/* harmony default export */ var custom_card_summary_CustomCardSummary = (CustomCardSummary);

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/payment/summary/custom-card-summary/index.ts


;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/payment/summary/Summary.tsx






var Summary = function(param) {
    var sender = param.sender, receiver = param.receiver, message = param.message, sendDate = param.sendDate, amount = param.amount, customGiftCardId = param.customGiftCardId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Summary_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_card_summary_CustomCardSummary, {
                customGiftCardId: customGiftCardId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Summary_module_default()).detailsContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Summary_module_default()).total,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                weight: "demiBold",
                                children: "Total"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                weight: "demiBold",
                                children: amount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Details, {
                        title: "Sender",
                        value: "".concat(sender.name, " - ").concat(sender.email)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Details, {
                        title: "Recipient",
                        value: (receiver === null || receiver === void 0 ? void 0 : receiver.name) ? "".concat(receiver.name, " - ").concat(receiver.email) : (receiver === null || receiver === void 0 ? void 0 : receiver.email) || ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Details, {
                        title: "Send date",
                        value: sendDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Details, {
                        title: "Your message",
                        value: message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditButton, {})
                ]
            })
        ]
    });
};
var Details = function(param) {
    var title = param.title, value = param.value;
    if (!value) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Summary_module_default()).details,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                weight: "demiBold",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                color: "grey-dark",
                children: value
            })
        ]
    });
};
var EditButton = function() {
    var router = (0,next_router.useRouter)();
    var handleClick = function() {
        router.back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseButton/* default */.Z, {
        type: "button",
        onClick: handleClick,
        className: (Summary_module_default()).editButton,
        children: "Edit"
    });
};
/* harmony default export */ var summary_Summary = (Summary);

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/payment/summary/index.ts


// EXTERNAL MODULE: ./blocks/e-gift-card/buy/payment/credit-card-form/CreditCardForm.module.scss
var CreditCardForm_module = __webpack_require__(30945);
var CreditCardForm_module_default = /*#__PURE__*/__webpack_require__.n(CreditCardForm_module);
// EXTERNAL MODULE: ./components/CreditCardElement/CreditCardElement.tsx + 15 modules
var CreditCardElement = __webpack_require__(94939);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/payment/credit-card-form/CreditCardForm.tsx



var CreditCardForm = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (CreditCardForm_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardElement/* default */.Z, {})
    });
};
/* harmony default export */ var credit_card_form_CreditCardForm = (CreditCardForm);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/payment/terms-and-conditions/TermsAndConditions.tsx



var TermsAndConditions = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
            children: [
                "By completing this e-gift card purchase I understand and agree to the",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/terms-and-conditions",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        children: "terms and conditions."
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var terms_and_conditions_TermsAndConditions = (TermsAndConditions);

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/payment/terms-and-conditions/index.ts


// EXTERNAL MODULE: ./components/icons/index.ts + 18 modules
var icons = __webpack_require__(30918);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js
var DialogActions = __webpack_require__(91894);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(35713);
// EXTERNAL MODULE: ./blocks/e-gift-card/buy/payment-confirmation/Modal.module.scss
var Modal_module = __webpack_require__(65335);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/payment-confirmation/Modal.tsx






var Modal = function(param) {
    var _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, onClose = param.onClose, shouldSendLater = param.shouldSendLater;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: isOpen,
        className: (Modal_module_default()).modal,
        fullWidth: true,
        PaperProps: PaperProps,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Modal_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                    className: (Modal_module_default()).actions,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                            className: (Modal_module_default()).closeIcon
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                    className: (Modal_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LittleEmperorsIcon */.IX, {
                            color: constants/* colorConstants.black */.Q_.black
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                            as: "h4",
                            children: "Thank you"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Heading */.X6, {
                            as: "h5",
                            children: [
                                "Your e-gift card",
                                " ",
                                shouldSendLater ? "will be sent as scheduled" : "has been sent"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                            children: "You will receive a confirmation email soon"
                        })
                    ]
                })
            ]
        })
    });
};
var PaperProps = {
    sx: {
        maxWidth: "540px",
        margin: 0,
        width: "100%",
        borderRadius: 0
    }
};
/* harmony default export */ var payment_confirmation_Modal = (Modal);

// EXTERNAL MODULE: ./blocks/e-gift-card/buy/payment/Payment.module.scss
var Payment_module = __webpack_require__(62567);
var Payment_module_default = /*#__PURE__*/__webpack_require__.n(Payment_module);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(58081);
;// CONCATENATED MODULE: ./api/vouchers/vouchers.ts



var createVouchers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(voucherData) {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api/* default.post */.ZP.post("/vouchers", voucherData)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function createVouchers(voucherData) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./api/vouchers/index.ts


// EXTERNAL MODULE: ./utils/serverValidationErrors.ts
var serverValidationErrors = __webpack_require__(87713);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/payment/utils.ts


var getRequestObject = function(state) {
    var vouchers = state.vouchers, creditCard = state.creditCard;
    var name = creditCard.name, number = creditCard.number, expiry = creditCard.expiry, cvc = creditCard.cvc;
    var ref = (0,_sliced_to_array/* default */.Z)(expiry.split("/"), 2), expMonth = ref[0], expYear = ref[1];
    var _vouchers = (0,_sliced_to_array/* default */.Z)(vouchers, 1), ref1 = _vouchers[0], creator_email = ref1.creator_email, creator_name = ref1.creator_name, currency = ref1.currency;
    var requestObj = {
        creator_email: creator_email,
        creator_name: creator_name,
        credit_card: {
            cvc: cvc,
            name: name,
            number: number,
            exp_month: expMonth,
            exp_year: expYear
        },
        currency: currency,
        vouchers: vouchers.map(function(voucher) {
            var returnedVoucher = {
                amount: Number(voucher.amount.replace(",", "")),
                currency: voucher.currency,
                recipient_email: voucher.recipient_email,
                send_at: moment_default()(voucher.send_date).unix(),
                custom_gift_card_id: voucher.custom_gift_card_id
            };
            if (voucher.self_send) {
                returnedVoucher.recipient_email = creator_email;
            }
            if (voucher.message) {
                returnedVoucher.message = voucher.message;
            }
            if (voucher.recipient_name) {
                returnedVoucher.recipient_name = voucher.recipient_name;
            }
            return returnedVoucher;
        })
    };
    return requestObj;
};

// EXTERNAL MODULE: ./services/StripeService/StripeService.ts
var StripeService = __webpack_require__(20415);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/payment/Payment.tsx



























var Payment = function() {
    var methods = (0,index_esm/* useForm */.cI)({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: {
            creditCard: {
                brand: "",
                number: "",
                expiry: "",
                cvc: "",
                name: ""
            }
        },
        resolver: (0,zod/* zodResolver */.F)(schemas/* signUpStep3Schema */.f_)
    });
    var handleSubmit = methods.handleSubmit, setError = methods.setError, errors = methods.formState.errors;
    var ref = useVoucherContext(), state = ref.state, resetState = ref.resetState;
    var vouchers = state.vouchers;
    var _vouchers = (0,_sliced_to_array/* default */.Z)(vouchers, 1), ref1 = _vouchers[0], amount = ref1.amount, creator_email = ref1.creator_email, creator_name = ref1.creator_name, message = ref1.message, recipient_email = ref1.recipient_email, recipient_name = ref1.recipient_name, send_date = ref1.send_date, currency = ref1.currency, send_date_option = ref1.send_date_option, custom_gift_card_id = ref1.custom_gift_card_id;
    var formattedSendDate = moment_default()(send_date).format("DD/MM/YYYY");
    var ref2 = (0,react.useState)(false), isConfirmationModalOpen = ref2[0], setIsConfirmationModalOpen = ref2[1];
    var router = (0,next_router.useRouter)();
    var ref3 = (0,useMutation/* useMutation */.D)(createVouchers, {
        onError: function(error) {
            var ref;
            var errorMsgObj = (0,serverValidationErrors/* getErrorMsgObj */.s_)(error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.data);
            if (Object.keys(errorMsgObj.credit_card).length === 0) {
                return;
            }
            var ref1 = (0,_sliced_to_array/* default */.Z)(Object.entries(errorMsgObj.credit_card)[0], 2), field = ref1[0], message = ref1[1];
            setError("creditCard.".concat(field), {
                type: "manual",
                message: message
            }, {
                shouldFocus: true
            });
        }
    }), isLoading = ref3.isLoading, mutateAsync = ref3.mutateAsync;
    var handleCloseModal = function() {
        setIsConfirmationModalOpen(false);
        router.replace("/e-gift-card");
        resetState();
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var requestObj, res, clientSecret, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestObj = getRequestObject((0,_object_spread/* default */.Z)({}, state, data));
                        return [
                            4,
                            mutateAsync(requestObj)
                        ];
                    case 1:
                        res = _state.sent();
                        if (!res.payment.requires_action) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        clientSecret = res.payment.client_secret;
                        return [
                            4,
                            StripeService/* default.shared */.Z.shared().handleCardAction(clientSecret)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        setError("creditCard", {
                            type: "manual",
                            message: (err === null || err === void 0 ? void 0 : err.message) || "An error occurred while processing your card. Please try again."
                        });
                        return [
                            2
                        ];
                    case 5:
                        setIsConfirmationModalOpen(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (Payment_module_default()).container,
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        as: "h2",
                        className: (Payment_module_default()).titleMobile,
                        children: "Payment"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_Summary, {
                        sender: {
                            email: creator_email,
                            name: creator_name
                        },
                        receiver: {
                            email: recipient_email,
                            name: recipient_name
                        },
                        sendDate: formattedSendDate,
                        message: message,
                        amount: (0,currencyHelper/* currencyHelper */.a)(Number(amount.replace(",", "")), currency),
                        customGiftCardId: custom_gift_card_id
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Payment_module_default()).creditCard,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                                as: "h2",
                                className: (Payment_module_default()).titleDesktop,
                                children: "Payment"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(credit_card_form_CreditCardForm, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_and_conditions_TermsAndConditions, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseButton/* default */.Z, {
                                isLoading: isLoading,
                                className: (Payment_module_default()).payNow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Lock, {}),
                                    "Pay now"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_confirmation_Modal, {
                isOpen: isConfirmationModalOpen,
                onClose: handleCloseModal,
                shouldSendLater: send_date_option === "later"
            })
        ]
    }));
};
/* harmony default export */ var payment_Payment = (Payment);

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/payment/index.ts


// EXTERNAL MODULE: ./components/Select/ControlledSelect.tsx
var ControlledSelect = __webpack_require__(61339);
// EXTERNAL MODULE: ./customHooks/useJoinUs/useJoinUs.ts
var useJoinUs = __webpack_require__(1698);
// EXTERNAL MODULE: ./blocks/sign-up/options.ts + 2 modules
var options = __webpack_require__(32239);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/currency-select/CurrencySelect.tsx







var CurrencySelect = function(param) {
    var name = param.name;
    var ref = useVoucherContext(), currencies = ref.state.currencies;
    var ref1 = (0,react.useContext)(useJoinUs/* JoinUsContext */.L), _joinUsState = ref1.joinUsState, defaultCurrency = _joinUsState.currency;
    var setValue = (0,index_esm/* useFormContext */.Gc)().setValue;
    (0,react.useEffect)(function() {
        if (!defaultCurrency) {
            return;
        }
        setValue(name, defaultCurrency);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        defaultCurrency
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledSelect/* ControlledSelect */.d, {
        name: name,
        label: "",
        options: (0,options/* getCurrencyOptionsVoucher */.bM)(currencies),
        layout: "CURRENCY"
    });
};
/* harmony default export */ var currency_select_CurrencySelect = (CurrencySelect);

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/currency-select/index.ts


// EXTERNAL MODULE: ./components/TextField/ControlledTextField.tsx
var ControlledTextField = __webpack_require__(17073);
// EXTERNAL MODULE: ./components/CheckBox/ControlledCheckBox.tsx
var ControlledCheckBox = __webpack_require__(46945);
// EXTERNAL MODULE: ./components/RadioButton/ControlledRadioButton.tsx
var ControlledRadioButton = __webpack_require__(46050);
// EXTERNAL MODULE: ./components/DateSelector/ControlledDateSelector.tsx + 2 modules
var ControlledDateSelector = __webpack_require__(11216);
// EXTERNAL MODULE: ./blocks/e-gift-card/buy/form/Form.module.scss
var Form_module = __webpack_require__(51299);
var Form_module_default = /*#__PURE__*/__webpack_require__.n(Form_module);
// EXTERNAL MODULE: ./blocks/e-gift-card/buy/form/amount-container/AmountContainer.module.scss
var AmountContainer_module = __webpack_require__(2192);
var AmountContainer_module_default = /*#__PURE__*/__webpack_require__.n(AmountContainer_module);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/utils.ts
//separate 1000s with commas
var separateThousands = function(value) {
    var normalizedValue = value;
    return normalizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
//strip 0 from the beginning of the string
var stripLeadingZero = function(value) {
    var normalizedValue = value;
    if (normalizedValue[0] === "0") {
        normalizedValue = "";
    }
    return normalizedValue;
};
var getInputName = function(index, name) {
    return "vouchers.".concat(index, ".").concat(name);
};

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/amount-container/AmountContainer.tsx





var AmountContainer = function(param) {
    var name = param.name, currencySymbol = param.currencySymbol, maxChars = param.maxChars;
    var normalizeAmountInput = function(value) {
        var normalizedValue = separateThousands(stripLeadingZero(value));
        return normalizedValue;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AmountContainer_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                name: name,
                placeholder: "0",
                onlyNumbers: true,
                maxChars: maxChars,
                normalize: normalizeAmountInput,
                prefix: currencySymbol,
                className: (AmountContainer_module_default()).textfield
            })
        })
    });
};
/* harmony default export */ var amount_container_AmountContainer = (AmountContainer);

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/amount-container/index.ts


;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/Form.tsx














var Form = function(param) {
    var index = param.index, isLast = param.isLast;
    var ref = (0,index_esm/* useFormContext */.Gc)(), watch = ref.watch, setValue = ref.setValue;
    var ref1 = useVoucherContext(), currencies = ref1.state.currencies;
    var today = new Date();
    var shouldSendLater = watch(getInputName(index, "send_date_option")) === "later";
    var shouldSelfSend = watch(getInputName(index, "self_send")) === true;
    var selectedCurrencyCode = watch(getInputName(index, "currency")) || "GBP";
    var selectedCurrency = currencies.find(function(currency) {
        return currency.code === selectedCurrencyCode;
    });
    var currencySymbol = (selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.symbol) || "";
    var selfSendMiddleware = function(checked) {
        setValue(getInputName(index, "recipient_email"), checked ? watch(getInputName(index, "creator_email")) : "");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Form_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
                        weight: "demiBold",
                        className: (Form_module_default()).amountTitle,
                        children: [
                            "Choose a gift card amount between ",
                            currencySymbol,
                            "50 and",
                            " ",
                            currencySymbol,
                            "1,500"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(amount_container_AmountContainer, {
                        name: getInputName(index, "amount"),
                        currencySymbol: currencySymbol,
                        maxChars: MAX_AMOUNT_DIGITS
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                        maxChars: MAX_NAME_CHARS,
                        name: getInputName(index, "creator_name"),
                        label: "Sender name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                        maxChars: MAX_EMAIL_CHARS,
                        name: getInputName(index, "creator_email"),
                        label: "Sender email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledCheckBox/* default */.Z, {
                        name: getInputName(index, "self_send"),
                        checked: false,
                        label: "Send the e-gift card only to me",
                        middleware: selfSendMiddleware
                    }),
                    !shouldSelfSend && /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                        maxChars: MAX_EMAIL_CHARS,
                        name: getInputName(index, "recipient_email"),
                        label: "Recipient email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                        maxChars: MAX_NAME_CHARS,
                        name: getInputName(index, "recipient_name"),
                        label: "Recipient name (optional)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Form_module_default()).sendDateOption,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledRadioButton/* default */.Z, {
                            name: getInputName(index, "send_date_option"),
                            options: [
                                {
                                    label: "Send now",
                                    value: "now"
                                },
                                {
                                    label: "Send later",
                                    value: "later"
                                }, 
                            ]
                        })
                    }),
                    shouldSendLater && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Form_module_default()).sendDate,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledDateSelector/* default */.Z, {
                            name: getInputName(index, "send_date"),
                            label: "Send date",
                            minDate: today.toString(),
                            dateFormat: SEND_DATE_DISPLAY_FORMAT
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledTextField/* ControlledTextField */.M, {
                        name: getInputName(index, "message"),
                        label: "Your message",
                        multiline: true,
                        minRows: 5
                    }),
                    isLast && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseButton/* default */.Z, {
                                size: "full",
                                children: "Continue"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Form_module_default()).currencySelect,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_select_CurrencySelect, {
                                    name: getInputName(index, "currency")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var form_Form = (Form);

// EXTERNAL MODULE: ./blocks/e-gift-card/buy/form/form-list/FormList.module.scss
var FormList_module = __webpack_require__(52562);
var FormList_module_default = /*#__PURE__*/__webpack_require__.n(FormList_module);
// EXTERNAL MODULE: ./blocks/e-gift-card/buy/shared/custom-card/CustomCard.module.scss
var CustomCard_module = __webpack_require__(45104);
var CustomCard_module_default = /*#__PURE__*/__webpack_require__.n(CustomCard_module);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/shared/custom-card/CustomCard.tsx






var CustomCard = function(param) {
    var index = param.index;
    var ref;
    var state = useVoucherContext().state;
    var customGiftCards = state.customGiftCards;
    if (!customGiftCards || customGiftCards.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackGiftCard, {});
    }
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), setValue = ref1.setValue, watch = ref1.watch, getValues = ref1.getValues;
    var fieldName = "vouchers.".concat(index, ".custom_gift_card_id");
    var ref2, ref3;
    var selectedCardId = (ref3 = (ref2 = watch(fieldName)) !== null && ref2 !== void 0 ? ref2 : getValues(fieldName)) !== null && ref3 !== void 0 ? ref3 : (ref = customGiftCards[0]) === null || ref === void 0 ? void 0 : ref.id;
    (0,react.useEffect)(function() {
        if (!getValues(fieldName)) {
            var ref;
            setValue(fieldName, (ref = customGiftCards[0]) === null || ref === void 0 ? void 0 : ref.id);
        }
    }, [
        fieldName,
        getValues,
        setValue,
        customGiftCards
    ]);
    var handleSelectCard = function(id) {
        setValue(fieldName, id);
    };
    var selectedCard = customGiftCards.find(function(card) {
        return card.id === selectedCardId;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CustomCard_module_default()).container,
        children: [
            selectedCard && selectedCard.image_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CustomCard_module_default()).selected,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: selectedCard.image_url,
                    alt: selectedCard.name
                })
            }, selectedCard.id),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CustomCard_module_default()).cta,
                children: "Choose a design"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CustomCard_module_default()).thumbs,
                children: customGiftCards.map(function(giftCard) {
                    return giftCard.image_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CustomCard_module_default()).thumbnail,
                        onClick: function() {
                            return handleSelectCard(giftCard.id);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: giftCard.image_url,
                            alt: giftCard.name
                        })
                    }, giftCard.id);
                })
            })
        ]
    });
};
/* harmony default export */ var custom_card_CustomCard = (CustomCard);

// EXTERNAL MODULE: ./blocks/e-gift-card/buy/form/form-list/intro-copy/IntroCopy.module.scss
var IntroCopy_module = __webpack_require__(10789);
var IntroCopy_module_default = /*#__PURE__*/__webpack_require__.n(IntroCopy_module);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/form-list/intro-copy/IntroCopy.tsx




var IntroCopy = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (IntroCopy_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (IntroCopy_module_default()).copy,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                    className: (IntroCopy_module_default()).introText,
                    children: "Whether it's a special occasion, a token of appreciation or a 'just because' treat, Little Emperors e-gift cards let you share a world of unforgettable hotels with the people you care about."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
                    className: (IntroCopy_module_default()).introText,
                    children: [
                        "And the cherry on top? New members who join with a gift card get",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "hideTablet"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: "6 months of Travel membership on us"
                        }),
                        ", so they can immediately unlock access to the best rates and most benefits at more than 5,000 luxury hotels."
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var intro_copy_IntroCopy = (IntroCopy);

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/form-list/intro-copy/index.ts


;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/form-list/intro-copy/IntroHeader.tsx




var IntroHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (IntroCopy_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (IntroCopy_module_default()).header,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                    as: "h1",
                    children: "Buy a Little Emperors e‑gift card"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                    className: (IntroCopy_module_default()).introText,
                    fontSize: 18,
                    weight: "demiBold",
                    children: "New members get 6 months of Travel membership on us!"
                })
            ]
        })
    });
};
/* harmony default export */ var intro_copy_IntroHeader = (IntroHeader);

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/form-list/FormList.tsx













var FormList = function() {
    var ref = useVoucherContext(), setState = ref.setState, state = ref.state;
    var methods = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(multiVoucherFormSchema),
        defaultValues: {
            vouchers: state.vouchers
        }
    });
    var control = methods.control, handleSubmit = methods.handleSubmit;
    var router = (0,next_router.useRouter)();
    var vouchers = (0,index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "vouchers"
    });
    var onSubmit = function(data) {
        //save form data to context and go to next step
        setState(data);
        router.push({
            query: {
                step: "payment"
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            className: (FormList_module_default()).form,
            onSubmit: handleSubmit(onSubmit),
            children: vouchers.fields.map(function(voucher, index) {
                var isFirst = index === 0;
                var isLast = index === vouchers.fields.length - 1;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FormList_module_default()).outerContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (FormList_module_default()).container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (FormList_module_default()).copy,
                                    children: isFirst && /*#__PURE__*/ (0,jsx_runtime.jsx)(intro_copy_IntroHeader, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (FormList_module_default()).spacer
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (FormList_module_default()).container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (FormList_module_default()).copy,
                                    children: [
                                        isFirst && /*#__PURE__*/ (0,jsx_runtime.jsx)(intro_copy_IntroCopy, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_card_CustomCard, {
                                            index: index
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (FormList_module_default()).form,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (FormList_module_default()).voucherContainer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_Form, {
                                                index: index,
                                                isLast: isLast
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }, voucher.id);
            })
        })
    }));
};
/* harmony default export */ var form_list_FormList = (FormList);

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/form/form-list/index.ts


// EXTERNAL MODULE: ./blocks/e-gift-card/buy/layout/Layout.module.scss
var Layout_module = __webpack_require__(96118);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/layout/Layout.tsx


var Layout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: (Layout_module_default()).container,
        children: children
    });
};
/* harmony default export */ var layout_Layout = (Layout);

;// CONCATENATED MODULE: ./blocks/e-gift-card/buy/layout/index.ts


// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
;// CONCATENATED MODULE: ./pages/luxury-hotels-e-gift-card/index.tsx










var Vouchers = function(param) {
    var globalLayoutProps = param.globalLayoutProps, currencies = param.currencies, customGiftCards = param.customGiftCards;
    var router = (0,next_router.useRouter)();
    var step = router.query.step;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherProvider, {
                currencies: currencies,
                customGiftCards: customGiftCards,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_Layout, {
                    children: [
                        step === "form" || !step && /*#__PURE__*/ (0,jsx_runtime.jsx)(form_list_FormList, {}),
                        step === "payment" && /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_Payment, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadApp/* default */.Z, {})
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var luxury_hotels_e_gift_card = (Vouchers);


/***/ }),

/***/ 28461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getDefaults; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45901);



function getDefaults(schema) {
    // Check if it's a ZodEffect
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema, zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodEffects */ .Xc)) {
        // Check if it's a recursive ZodEffect
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema.innerType(), zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodEffects */ .Xc)) return getDefaults(schema.innerType());
        // return schema inner shape as a fresh zodObject
        return getDefaults(zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodObject.create */ .CQ.create(schema.innerType().shape));
    }
    function getDefaultValue(schema) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema, zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodDefault */ .uE)) return schema._def.defaultValue();
        // return an empty array if it is
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema, zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodArray */ .p5)) return [];
        // return an empty string if it is
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema, zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodString */ .$T)) return "";
        // return an content of object recursively
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(schema, zod__WEBPACK_IMPORTED_MODULE_1__/* .ZodObject */ .CQ)) return getDefaults(schema);
        if (!("innerType" in schema._def)) return undefined;
        return getDefaultValue(schema._def.innerType);
    }
    return Object.fromEntries(Object.entries(schema.shape).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return [
            key,
            getDefaultValue(value)
        ];
    }));
}


/***/ }),

/***/ 51299:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__SmDLG","amountTitle":"Form_amountTitle__eGwGY","sendDateOption":"Form_sendDateOption__GcmVu","sendDate":"Form_sendDate__pMIDl"};

/***/ }),

/***/ 2192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AmountContainer_container__W1atN","textfield":"AmountContainer_textfield__kgZBf"};

/***/ }),

/***/ 52562:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"FormList_outerContainer__jj2kg","container":"FormList_container__zOtHu","copy":"FormList_copy__oABBr","voucherContainer":"FormList_voucherContainer__NzNt5","spacer":"FormList_spacer__aujBm","form":"FormList_form__StRHp","introText":"FormList_introText__uQ2OP"};

/***/ }),

/***/ 10789:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"IntroCopy_container__4glWV","header":"IntroCopy_header__uibbI","copy":"IntroCopy_copy__PCbG8"};

/***/ }),

/***/ 96118:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__5vLSD"};

/***/ }),

/***/ 65335:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__r0oO7","content":"Modal_content__NBqcE","actions":"Modal_actions__MuLu2","closeIcon":"Modal_closeIcon__u5qE7"};

/***/ }),

/***/ 62567:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Payment_container__e3kd7","titleMobile":"Payment_titleMobile__CJmsw","titleDesktop":"Payment_titleDesktop__GOfMx","payNow":"Payment_payNow__JtRti","creditCard":"Payment_creditCard__8e7kU"};

/***/ }),

/***/ 30945:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CreditCardForm_container__HqIeJ"};

/***/ }),

/***/ 42488:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Summary_container__Nskf3","detailsContainer":"Summary_detailsContainer__4npsY","details":"Summary_details__JHrb8","total":"Summary_total___LZY0","editButton":"Summary_editButton__0QaxY"};

/***/ }),

/***/ 13652:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomCardSummary_container__WXd8e","imageContainer":"CustomCardSummary_imageContainer__Tp__t"};

/***/ }),

/***/ 45104:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomCard_container__vk3__","thumbs":"CustomCard_thumbs__tkumh","thumbnail":"CustomCard_thumbnail__dOQxf","selected":"CustomCard_selected__UvWMj","fadeIn":"CustomCard_fadeIn__9j4fx","scaleUp":"CustomCard_scaleUp__u7IqK","cta":"CustomCard_cta__w6QJi"};

/***/ }),

/***/ 78717:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CountryCode_container__dsYpw","flag":"CountryCode_flag__ThfPv","dialCode":"CountryCode_dialCode__fzs2o","name":"CountryCode_name__gL0dT"};

/***/ }),

/***/ 93636:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radioContainer":"RadioButton_radioContainer__PA7O8","radioButton":"RadioButton_radioButton__Sd7OI","error":"RadioButton_error__n4cO5"};

/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 48228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ useMutation; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/mutation.mjs
var mutation = __webpack_require__(89886);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/mutationObserver.mjs





// CLASS
class MutationObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.setOptions(options);
    this.bindMethods();
    this.updateResult();
  }

  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }

  setOptions(options) {
    var _this$currentMutation;

    const prevOptions = this.options;
    this.options = this.client.defaultMutationOptions(options);

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getMutationCache().notify({
        type: 'observerOptionsUpdated',
        mutation: this.currentMutation,
        observer: this
      });
    }

    (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.setOptions(this.options);
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$currentMutation2;

      (_this$currentMutation2 = this.currentMutation) == null ? void 0 : _this$currentMutation2.removeObserver(this);
    }
  }

  onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    const notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  }

  getCurrentResult() {
    return this.currentResult;
  }

  reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  }

  mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, { ...this.options,
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    });
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  }

  updateResult() {
    const state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();
    const isLoading = state.status === 'loading';
    const result = { ...state,
      isLoading,
      isPending: isLoading,
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = result;
  }

  notify(options) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the mutate callbacks
      if (this.mutateOptions && this.hasListeners()) {
        if (options.onSuccess) {
          var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;

          (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null ? void 0 : _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (options.onError) {
          var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;

          (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null ? void 0 : _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        this.listeners.forEach(({
          listener
        }) => {
          listener(this.currentResult);
        });
      }
    });
  }

}


//# sourceMappingURL=mutationObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(464);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(24798);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs
'use client';






function useMutation(arg1, arg2, arg3) {
  const options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const [observer] = react.useState(() => new MutationObserver(queryClient, options));
  react.useEffect(() => {
    observer.setOptions(options);
  }, [observer, options]);
  const result = (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [observer]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  const mutate = react.useCallback((variables, mutateOptions) => {
    observer.mutate(variables, mutateOptions).catch(noop);
  }, [observer]);

  if (result.error && (0,lib_utils/* shouldThrowError */.L)(observer.options.useErrorBoundary, [result.error])) {
    throw result.error;
  }

  return { ...result,
    mutate,
    mutateAsync: result.mutate
  };
} // eslint-disable-next-line @typescript-eslint/no-empty-function

function noop() {}


//# sourceMappingURL=useMutation.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,5675,5901,1657,1736,2567,2334,6312,6745,4520,5989,9510,7369,9774,2888,179], function() { return __webpack_exec__(54535); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);